import { Component, Input, ViewChild } from '@angular/core'
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter'
import { DateAdapter, ErrorStateMatcher, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { MatDatepicker } from '@angular/material/datepicker'
import moment, { Moment } from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD'

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    yearLabel: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    yearA11yLabel: 'YYYY',
  },
}

@Component({
  selector: 'bdg-year-date-field',
  templateUrl: './date-field-year.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_FORMATS,
    },
  ],
})
export class DateFieldYearComponent implements ErrorStateMatcher {
  @Input()
  control: FormControl
  @Input()
  label: ''
  @Input()
  hint: ''

  @ViewChild('datePicker')
  picker: MatDatepicker<moment.Moment>

  date = moment()

  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.date = this.date.year(normalizedYear.year())
    this.control.setValue(moment(this.date).format(MY_FORMATS.parse.dateInput))
    datepicker.close()
  }

  onPickerClicked() {
    this.picker.open()
  }

  get matcher() {
    return this as ErrorStateMatcher
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  isErrorState(_: FormControl, form: FormGroupDirective | NgForm): boolean {
    return this.error()
  }
}
